import { DatePipe } from "@angular/common";
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom, provideAppInitializer, inject, provideZoneChangeDetection } from "@angular/core";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
  withViewTransitions,
} from "@angular/router";

import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { MatSnackBarModule } from "@angular/material/snack-bar";

import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { LocalStorageService } from "./core/services/local-storage.service";
import { ObservableService } from "./core/services/observable.service";
import { SessionStorageService } from "./core/services/session-storage.service";
import { TranslationService } from "./core/services/translation.service";

import { appRoutes as APP_ROUTES } from "./app.routes";

import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { interceptors } from "./core/interceptors/interceptor-list";

const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  appearance: "outline",
  subscriptSizing: "dynamic",
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom([BrowserAnimationsModule]),
    importProvidersFrom(MatSnackBarModule),
    provideAnimations(),

    SessionStorageService,
    LocalStorageService,
    ObservableService,

    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: "always" }),
      withViewTransitions(),
    ),

    provideHttpClient(withXhr(), withInterceptors(interceptors)),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(MatDatepickerModule, MatNativeDateModule),

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "/assets/i18n/",
        suffix: ".json",
        useHttpBackend: true,
      }),
    }),
    provideAppInitializer(() => {
      inject(TranslationService).init();
    }),

    DatePipe,

    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: matFormFieldDefaultOptions },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
      },
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true },
    },
  ],
};
